import { Link } from "react-router-dom";

import { DESIGN_PARTNER_PATHS } from "../routes";

export function AccessPage() {
  return (
    <section className="page" id="access" data-testid="dp-page-access">
      <div className="wrap policy">
        <div className="eyebrow">Partner access</div>
        <h1>Access is invitation-only during the design-partner phase.</h1>
        <p className="lead">
          Zephix is not offering self-serve accounts or a public trial at this stage. Selected
          organizations receive access only after a discovery conversation and a mutually agreed
          pilot workflow.
        </p>
        <Link className="btn primary" to={DESIGN_PARTNER_PATHS.apply}>
          Request a conversation →
        </Link>
      </div>
    </section>
  );
}
